import { useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { useAuth } from '@/contexts'
import { Button, Input } from '@/components/common'

export function ResetPasswordForm() {
    const { resetPassword } = useAuth()
    const { email: emailFromQuery } = useParams()

    const [email, setEmail] = useState(emailFromQuery || '')
    const [code, setCode] = useState('')
    const [password, setPassword] = useState('')

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault()

        resetPassword(email, code, password)
    }

    return (
        <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
            <Link to="/" className="flex items-center mb-6 text-2xl font-semibold text-gray-900 dark:text-white">
                <img src="/logo.svg" alt="Logo" className="w-80" />
            </Link>
            <div className="w-full bg-white shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
                <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                    <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">Reset Password</h1>
                    <form className="space-y-4 md:space-y-6" onSubmit={handleSubmit}>
                        <Input
                            type="email"
                            name="email"
                            id="email"
                            aria-describedby="email"
                            autoComplete="email"
                            placeholder="name@company.com"
                            label="E-mail"
                            value={email}
                            setValue={setEmail}
                            disabled={!!emailFromQuery}
                            required
                        />

                        <Input
                            name="code"
                            id="code"
                            label="Code"
                            aria-describedby="code"
                            placeholder="123456"
                            value={code}
                            setValue={setCode}
                            required
                        />

                        <Input
                            type="password"
                            name="password"
                            id="password"
                            label="Neues Passwort"
                            aria-describedby="password"
                            placeholder="••••••••"
                            autoComplete="new-password"
                            value={password}
                            setValue={setPassword}
                            required
                        />

                        <Button type="submit" label="Neues Passwort festlegen" />

                        <p className="text-sm font-light text-gray-500 dark:text-gray-400">
                            Noch kein Konto?{' '}
                            <Link to="/start" className="font-medium text-pink-600 hover:underline dark:text-pink-600">
                                Hier beginnen
                            </Link>
                        </p>
                    </form>
                </div>
            </div>
        </div>
    )
}
